import styled from "styled-components";

interface MenuItemsContainerProps {
  isopenalltrue: boolean;
}

export const MenuItemsContainer = styled.div<MenuItemsContainerProps>`
  width: 250px;
  padding: 10px;
  position: absolute;
  z-index: 10;
  background-color: #fff;
  box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2),
    0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
    top: ${() => (
    localStorage.getItem("tabViewMenu") === "true" ? "173px" : "150px"
)};
 
  @media only screen and (max-width: 360px) {
    top: 180px;
    /* display: none; */
  }
  .search-box {
    display: flex;
    width: 100%;
  }
  .menu-items {
    display: flex;
    flex-direction: column;
    height: 200px;
    overflow-y: scroll;
    padding-right: 5px;
  }
  .itemList {
    display: flex;
    justify-content: space-between;
    margin-bottom: 6px;
  }
  .itemName {
    font-size: 12px;
    font-weight: 500;
    text-transform: capitalize;
  }

  .footer-buttons {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
  }
  .buttons {
    color: #00a4e5;
    font-weight: 600;
    cursor: pointer;
  }
`;
